module.exports = __webpack_public_path__ + "static/media/feedback.6ae77b2a.png";